import React from "react";
import {Button, Col, Row} from "react-bootstrap";
import {formatTransferEvent, outcomeOptions} from "./constants";
import {transportTypes} from "../../../../../_data/mydata/transportTypes";
import {packagingTypes} from "../../../../../_data/mydata/packagingTypes";
import {FaEye, FaLink} from "react-icons/fa";
import {FaShareFromSquare} from "react-icons/fa6";
import {toast} from "react-toastify";
import {measurementUnitsData} from "../../../../../_data/mydata/measurementUnits";
import {openSale} from "../../../../../_helpers/tabOpeners";
import {useDispatch, useSelector} from "react-redux";
import TransfersActionButtons from "./TransfersActionButtons";

export const TransferInfo = ({transferData, refreshCallback}) => {
    const dispatch = useDispatch();
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);

    const handleOpenURL = () => {
        window.open(transferData.qrUrl, "_blank");
    }

    const handleCopyURL = () => {
        navigator.clipboard.writeText(transferData.qrUrl).then(() => {
            toast.info("Επιτυχής αντιγραφή συνδέσμου.", {autoClose: 1000});
        });
    }

    const handleOpenLocal = () => {
        openSale(dispatch, TABS_DATA, company.id, transferData.erp_id);
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={8}>
                    <div className={"text-left mb-2"}>
                        <Button size={"sm"} onClick={() => handleOpenURL()}>
                            <FaShareFromSquare className={"mr-1"}/>
                            Άνοιγμα ιστοσελίδας
                        </Button>
                        <Button size={"sm"} className={"ml-2"} onClick={() => handleCopyURL()}>
                            <FaLink className={"mr-1"}/>
                            Αντιγραφή συνδέσμου
                        </Button>
                        {transferData.erp_id && (
                            <Button size={"sm"} className={"ml-2"} onClick={() => handleOpenLocal()}>
                                <FaEye className={"mr-1"}/>
                                Προβολή παραστατικού
                            </Button>
                        )}
                    </div>
                    <div className={"text-muted mb-1"}><i>Πίνακας ειδών</i></div>
                    <table className={"transfers-table"}>
                        <thead>
                        <tr>
                            <th>Κωδικός Είδους</th>
                            <th>Όνομα Είδους</th>
                            <th>Μ.Μ.</th>
                            <th>Ποσότητα</th>
                        </tr>
                        </thead>
                        <tbody style={{maxHeight: "350px", overflowY: "auto"}}>
                        {transferData.products?.length > 0 && transferData.products.map((prod, idx) => (
                            <tr key={`pro-${idx}`}>
                                <td data-label="Κωδικός Είδους">{prod.code}</td>
                                <td data-label="Όνομα Είδους">{prod.name}</td>
                                <td data-label="Μ.Μ.">{measurementUnitsData.find((el) => String(el.id) === String(prod.measurementUnit))?.name || prod.measurementUnit}</td>
                                <td data-label="Ποσότητα">{prod.quantity}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    {transferData?.packingsDeclarations?.length > 0 && (
                        <React.Fragment>
                            <div className={"text-muted mb-1 mt-2"}><i>Δηλώσεις Συσκευασιών</i></div>
                            <Row>
                                {transferData.packingsDeclarations.map((pd, idx) => (
                                    <Col md={4} idx={`pd-${idx}`}>
                                        <div className={"subscription-box"} style={{backgroundColor: "white"}}>
                                            <div style={{margin: "10px"}}>
                                                <span style={{fontWeight: "600"}}>Είδος Συσκευασίας: </span>{packagingTypes.find((el) => String(el.value) === String(pd.packagingType)).label}<br/>
                                                {(pd.otherPackagingTypeTitle && pd.packagingType === "6") && (
                                                    <React.Fragment>
                                                        <span style={{fontWeight: "600"}}>Τίτλος για Λοιπά Είδη Συσκευασίας: </span>{pd.otherPackagingTypeTitle}<br/>
                                                    </React.Fragment>
                                                )}
                                                <span style={{fontWeight: "600"}}>Ποσότητα: </span> {pd.quantity}<br/>
                                            </div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </React.Fragment>
                    )}
                </Col>
                <Col md={4}>
                    <div className={"text-muted mb-1"}><i>Ιστορικό Κινήσεων Δ.Α.</i></div>
                    {transferData.lifecycleHistory.map((lc, idx) => (
                        <div className={`subscription-box mb-2`} style={{backgroundColor: "white"}} key={`lc-${idx}`}>
                            <div style={{margin: "10px"}}>
                                <span style={{fontWeight: "600"}}>Γεγονός: </span>{formatTransferEvent(lc.eventType)}<br/>
                                <span style={{fontWeight: "600"}}>MARK: </span>{lc.mark}<br/>
                                {lc.eventType === "RegisterTransfer" && (
                                    <React.Fragment>
                                        <hr className={"mt-1 mb-1"} />
                                        <span style={{fontWeight: "600"}}>Αρ. Οχήματος: </span>{lc.vehicleNumber}<br/>
                                        <span style={{fontWeight: "600"}}>Τύπος Οχήματος: </span>{transportTypes.find((el) => el.value === lc.transportType).label}<br/>
                                    </React.Fragment>
                                )}
                                {lc.eventType === "ConfirmOutcome" && (
                                    <React.Fragment>
                                        <hr className={"mt-1 mb-1"} />
                                        <span style={{fontWeight: "600"}}>Αποτέλεσμα: </span>{outcomeOptions.find((el) => el.value === lc.outcome).label}<br/>
                                    </React.Fragment>
                                )}
                                {lc.eventType === "Rejection" && (
                                    <React.Fragment>
                                        <hr className={"mt-1 mb-1"} />
                                        <span style={{fontWeight: "600"}}>Λόγος Απόρριψης: {lc.rejectionReason}</span><br/>
                                    </React.Fragment>
                                )}
                            </div>
                        </div>
                    ))}
                </Col>
            </Row>

            <TransfersActionButtons
                selectedRows={[transferData]}
                successCallback={() => {
                    if (refreshCallback) refreshCallback();
                }}
                showInvalid={false}
            />
        </React.Fragment>
    )
}